angular.module('qkr.merchant.reports').config($routeSegmentProvider => {
  const reportsResolve = {
    reports(reportService) {
      'ngInject';
      return reportService.loadSavedReports(null);
    },
    merchantInfo(merchantService) {
      'ngInject';
      return merchantService.loadMerchantResponse();
    },
    outlets(outletService, $routeParams) {
      'ngInject';
      return $routeParams.outletId ? // this is weird
        outletService.loadOutletDepartments($routeParams.outletId) : [];
    }
  };

  $routeSegmentProvider
    .when('/merchant/reports', 'merchantreports')
    .when('/merchant/reports/view', 'merchantreports.view')
    .when('/merchant/reports/schedule', 'merchantreports.schedule')
    .when('/merchant/reports/current', 'merchantreports.current')
    .when('/merchant/outlet/:outletId?/reports', 'reports', { pageTitle: 'Reports' })
    .when('/merchant/outlet/:outletId?/reports/view', 'reports.view', { pageTitle: 'Reports' })
    .when('/merchant/outlet/:outletId?/reports/schedule', 'reports.schedule', { pageTitle: 'Reports' })
    .when('/merchant/outlet/:outletId?/reports/current', 'reports.current', { pageTitle: 'Reports' })
    .when('/byorview/:outletId?', 'byorview')
    .when('/byorschedule/:outletId?', 'byorschedule')
    .when('/byoredit/:outletId?/:id', 'byoredit');

  $routeSegmentProvider
    .segment('merchantreports', {
      template: '<merchantreports></merchantreports>'
    })
    .within()
    .segment('view', {
      default: true,
      template: require('./merchant/view/view.html'),
      controller: 'ViewMerchantReportsController',
      controllerAs: 'vm',
      resolve: {
        merchantInfo(merchantService) {
          'ngInject';
          return merchantService.loadMerchantResponse();
        }
      },
      untilResolved: { template: require('../shared/loading-screen.html') },
      resolveFailed: { template: require('../shared/loading-error.html') }
    })
    .segment('schedule', {
      template: require('./merchant/schedule/schedule.html'),
      controller: 'ScheduleMerchantReportsController',
      controllerAs: 'vm',
      resolve: {
        merchantInfo(merchantService) {
          'ngInject';
          return merchantService.loadMerchantResponse();
        }
      },
      untilResolved: { template: require('../shared/loading-screen.html') },
      resolveFailed: { template: require('../shared/loading-error.html') }
    })
    .segment('current', {
      template: require('./outlet/current/current.html'),
      controller: 'CurrentReportsController',
      controllerAs: 'vm',
      resolve: reportsResolve,
      dependencies: [],
      untilResolved: { template: require('../shared/loading-screen.html') },
      resolveFailed: { template: require('../shared/loading-error.html') }
    })
    .up()
    .segment('reports', { template: '<reports></reports>' })
    .within()
    .segment('view', {
      default: true,
      template: require('./outlet/view/view.html'),
      controller: 'ViewReportsController',
      controllerAs: 'vm',
      resolve: {
        merchantInfo(merchantService) {
          'ngInject';
          return merchantService.loadMerchantResponse();
        }
      },
      dependencies: [ 'outletId' ],
      untilResolved: { template: require('../shared/loading-screen.html') },
      resolveFailed: { template: require('../shared/loading-error.html') }
    })
    .segment('schedule', {
      template: require('./outlet/schedule/schedule.html'),
      controller: 'ScheduleReportsController',
      controllerAs: 'vm',
      resolve: {
        merchantInfo(merchantService) {
          'ngInject';
          return merchantService.loadMerchantResponse();
        }
      },
      dependencies: [ 'outletId' ],
      untilResolved: { template: require('../shared/loading-screen.html') },
      resolveFailed: { template: require('../shared/loading-error.html') }
    })
    .segment('current', {
      template: require('./outlet/current/current.html'),
      controller: 'CurrentReportsController',
      controllerAs: 'vm',
      resolve: reportsResolve,
      dependencies: [ 'outletId' ],
      untilResolved: { template: require('../shared/loading-screen.html') },
      resolveFailed: { template: require('../shared/loading-error.html') }
    })
    .up()
    .segment('byorview', {
      controller: 'ByorController',
      controllerAs: 'vm',
      template: require('./outlet/byor/byor.html'),
      dependencies: [ 'outletId' ],
      resolve: {
        departments(outletService, $routeParams) {
          'ngInject';
          return outletService.loadOutletDepartments($routeParams.outletId);
        },
        columns(byorService) {
          'ngInject';
          return byorService.getColumns();
        },
        reportSpec: () => null,
        // generating is true for view
        generating: () => true
      },
      untilResolved: { template: require('../shared/loading-screen.html') },
      resolveFailed: { template: require('../shared/loading-error.html') }
    })
    .segment('byorschedule', {
      controller: 'ByorController',
      controllerAs: 'vm',
      template: require('./outlet/byor/byor.html'),
      dependencies: [],
      resolve: {
        departments(outletService, $routeParams) {
          'ngInject';
          return outletService.loadOutletDepartments($routeParams.outletId);
        },
        columns(byorService) {
          'ngInject';
          return byorService.getColumns();
        },
        reportSpec: () => null,
        // generating is false for schedule
        generating: () => false
      },
      untilResolved: { template: require('../shared/loading-screen.html') },
      resolveFailed: { template: require('../shared/loading-error.html') }
    })
    .segment('byoredit', {
      controller: 'ByorController',
      controllerAs: 'vm',
      dependencies: [ 'id' ],
      template: require('./outlet/byor/byor.html'),
      resolve: {
        departments(outletService, $routeParams) {
          'ngInject';
          return outletService.loadOutletDepartments($routeParams.outletId);
        },
        columns(byorService) {
          'ngInject';
          return byorService.getColumns();
        },
        reportSpec($routeParams, byorService) {
          'ngInject';
          return byorService.getByorReportSpec($routeParams.id);
        },
        generating: () => false
      },
      untilResolved: { template: require('../shared/loading-screen.html') },
      resolveFailed: { template: require('../shared/loading-error.html') }
    });
});



// WEBPACK FOOTER //
// ./src/reports/reports.config.js